import { toast } from "sonner";
import i18n from "@/lib/i18n";

/** Thrown from admin menu mutations when creating a row without an active `restaurantId`. */
export const RESTAURANT_REQUIRED_FOR_MUTATION = "RESTAURANT_REQUIRED";

/** Shows the restaurant-required toast when `error` matches; returns whether it did. */
export function onErrorRestaurantRequired(error: unknown): boolean {
  if (
    !(error instanceof Error) ||
    error.message !== RESTAURANT_REQUIRED_FOR_MUTATION
  ) {
    return false;
  }
  toast.error(i18n.t("admin:ui.common.error"), { description: i18n.t("admin:ui.menuAddOnCategoryDialog.restaurantRequired") });
  return true;
}

export function errMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === "object" && e !== null && "message" in e) {
    return String((e as { message: unknown }).message);
  }
  return String(e) || i18n.t("admin:auth.toastErrorGeneric");
}

export function onErrorGeneric(error: unknown) {
  const message = errMessage(error) || i18n.t("admin:auth.toastErrorGeneric");
  toast.error(i18n.t("admin:auth.toastErrorTitle"), { description: message });
}
